import { render, staticRenderFns } from "./AlertsTab.vue?vue&type=template&id=17bf3f78&scoped=true"
import script from "./AlertsTab.vue?vue&type=script&lang=js"
export * from "./AlertsTab.vue?vue&type=script&lang=js"
import style0 from "./AlertsTab.vue?vue&type=style&index=0&id=17bf3f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf3f78",
  null
  
)

export default component.exports